import { render, staticRenderFns } from "./ManagerInvite.vue?vue&type=template&id=68124fe0&lang=pug&"
import script from "./ManagerInvite.vue?vue&type=script&lang=js&"
export * from "./ManagerInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports